/*
支付方式有如下几种：
 1、WX_JSAPI, 微信JS
 2、WX_NATIVE, 微信原生
 3、ALI_PAY_WAP, 支付宝WAP
 4、ALI_PAY_DIRECT， 支付宝APP
 5、WX_H5_PAY，微信H5支付
 */
// import PINGPP from 'pingpp-js';

/**
 *
 * @param DATA jsAPiJson
 * @param callback
 */
export function wxJsPay(DATA, callback) {
  /*  这方法完成2个步骤
     1、生成支付订单，返回支付参数
     2、根据支付参数调用JSAPI请求支付，返回验证结果，用户输入密码
     3、验证授权
     */

  wx.ready(function() {
    wx.chooseWXPay({
      timestamp: DATA.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: DATA.nonceStr, // 支付签名随机串，不长于 32 位
      package: DATA.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
      signType: DATA.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      paySign: DATA.paySign, // 支付签名
      success: function (res) {
        // 支付成功后的回调函数
        callback(res);
      },
      fail: function(res) {
        callback(res);
      },
      cancel: function(res) {
        callback(res);
      }
    });
  })
}
/**
 *
 * @param DATA PING++ JSON Obj
 * @param callback
 */
export function aliPayWap(DATA, callback) {
  // 支付宝WAP
  PINGPP.createPayment(DATA, (result, err) => {
    if (result === 'success') {
      if (typeof (callback) === 'function') {
        callback();
      }
    } else if (result === 'fail') {
      // data 不正确或者微信公众账号/微信小程序/QQ 公众号/支付宝口碑支付失败时会在此处返回
      window.monitor.stat({
        level: 'error',
        error: 'API-data',
        url: location.href,
        message: 'PINGPP支付失败',
        remark: err
      });
    } else if (result === 'cancel') {
      // 微信公众账号、微信小程序、QQ 公众号、支付宝口碑支付取消支付
      window.monitor.stat({
        level: 'error',
        error: 'API-data',
        url: location.href,
        message: 'PINGPP支付取消',
        remark: err
      });
    }
  })
}

// ping++集成支付接口
export function pingppPay(charge) {
  console.log('PINGPP.createPayment 的 charge', charge)
  // ping++ 现在接入了微信支付和支付宝支付，所以名字也改一下
  PINGPP.createPayment(charge, function(result, err) {
    console.log('result', result)
    console.log('err', err.msg)
    console.log('err', err.extra)
    if (result === 'success') {
      console.log('pingppPay 支付成功')
    } else if (result === 'fail') {
      console.log('pingppPay 支付失败')
    } else if (result === 'cancel') {
      console.log('pingppPay 取消支付')
    }
  })
}

// 支付宝直连
export function directAliPay(DATA) {
  return new Promise(() => {
    // 直连的话拿返回的模拟表单提交直接提交
    console.log(DATA)
    const div = document.createElement('div')
    div.innerHTML = DATA
    div.setAttribute('id', 'directAliPayDom')
    !document.getElementById('directAliPayDom') ? document.body.appendChild(div) : document.body.replaceChild(div, document.getElementById('directAliPayDom'))
    document.forms[0].submit()
  })
}

export default {
  wxJsPay,
  aliPayWap,
  pingppPay,
  directAliPay
}



// WEBPACK FOOTER //
// ./src/lib/payUnit.js